import React from 'react';
import { Box, SelectChangeEvent } from '@mui/material';
import { SxProps } from '@mui/system';

import SingleSelect from '@components/SingleSelect';
import { STEP_TESTS } from '@core/devices/constants/devicesSteps';
import { DTMicroIcon, DTSpeakerIcon } from '@icons';

import { IProgressBarSelection } from './interfaces';
import { useStyles } from './styles';

const ProgressBarSelection = ({
  devices,
  activeDeviceId,
  onDeviceChange,
  disabled,
  sx = {},
  typeOfDevice = STEP_TESTS.MICROPHONE,
}: IProgressBarSelection) => {
  const classes = useStyles();
  const rootSx = { ...classes.root, ...sx } as SxProps;

  const options = React.useMemo(
    () =>
      devices.map((device) => ({
        label: device.label,
        value: device.deviceId,
      })),
    [devices],
  );

  const handleChange = React.useCallback(
    (event: SelectChangeEvent) => {
      onDeviceChange(event.target.value);
    },
    [onDeviceChange],
  );

  return (
    <Box sx={rootSx}>
      {typeOfDevice === STEP_TESTS.MICROPHONE && (
        <DTMicroIcon sx={classes.icon} />
      )}
      {typeOfDevice === STEP_TESTS.SPEAKER && (
        <DTSpeakerIcon sx={classes.icon} />
      )}
      <SingleSelect
        options={options}
        activeValue={activeDeviceId || devices[0].deviceId}
        onChange={handleChange}
        disabled={disabled}
        emptyPlaceholder="No available devices"
        sx={classes.select}
        menuProps={{
          PaperProps: {
            sx: classes.paper,
          },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'center',
          },
        }}
      />
    </Box>
  );
};

export default ProgressBarSelection;
